// extracted by mini-css-extract-plugin
export default {"container":"SyncFromCrmConfirmationDialog_container__dDIPZ","text":"SyncFromCrmConfirmationDialog_text__gq1wM"};